import { useMemo } from 'react';
import useAnchorLink from './useAnchorLink';

export const useAnchorLinkWithHiddenParams = (externalPath: string, externalParams?: Record<string, string>) => {
  const fullUrl = useMemo(() => {
    if (!externalParams) return externalPath;
    const hasQueryParams = externalPath.includes('?');
    const queryParamPrefix = hasQueryParams ? '&' : '?';
    const queryString = Object.entries(externalParams)
      .map(([ key, value ]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
    return`${externalPath}${queryParamPrefix}${queryString}`;
  }, [ externalPath, externalParams ]);

  const link = useAnchorLink(fullUrl);

  return link;
};

